import { useLiveQuery } from 'dexie-react-hooks';
import { PageHeader } from '@/components/PageHeader';
import { leerSettings } from '@/db/schema';
import { RestaurarRespaldo } from './RestaurarRespaldo';
import { CifradoRespaldos } from './CifradoRespaldos';
import { CopiasInternas } from './CopiasInternas';
import { VOLVER_A_RESPALDOS } from './BackupPage';

/** Respaldos → Revisar y restaurar (Req. 6.5 a 6.11, 6.14, 6.15, 6.22). */
export function RestorePage() {
  return (
    <div>
      <PageHeader
        titulo="Recupera tus datos."
        descripcion="Primero revisas el archivo. Nada cambia hasta que lo confirmes."
        volver={VOLVER_A_RESPALDOS}
      />
      <RestaurarRespaldo />
    </div>
  );
}

/** Respaldos → Protección con contraseña (Req. 6.18 a 6.23). */
export function EncryptionPage() {
  const settings = useLiveQuery(() => leerSettings(), []);
  if (settings === undefined) return null;
  return (
    <div>
      <PageHeader
        titulo="Un poco más de privacidad."
        descripcion="Protege tus archivos de respaldo con contraseña, por si alguien más los llega a abrir."
        volver={VOLVER_A_RESPALDOS}
      />
      <CifradoRespaldos key={`cifrado-${settings.perfilId}`} settings={settings} />
    </div>
  );
}

/** Respaldos → Copias internas (Req. 2.10, 6.10, 6.11). */
export function CopiesPage() {
  return (
    <div>
      <PageHeader
        titulo="Una vuelta atrás."
        descripcion="La app guarda estas copias sola antes de restaurar o de actualizar tus datos. Viven en este mismo teléfono: no sustituyen un respaldo."
        volver={VOLVER_A_RESPALDOS}
      />
      <CopiasInternas />
    </div>
  );
}
